// extracted by mini-css-extract-plugin
export var chip = "_rn-2";
export var chipBody = "_rn-8";
export var chipHeader = "_rn-9";
export var chipWithKind = "_rn-7";
export var icon = "_rn-3";
export var kind = "_rn-a";
export var remove = "_rn-5";
export var removeIcon = "_rn-6";
export var row = "_rn-0";
export var rowHistorical = "_rn-1";
export var text = "_rn-4";